import { keyframes, type Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

const sweep = keyframes`
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
`;

/**
 * A "still working" text treatment: a left-to-right `edge → band → edge`
 * gradient clipped to the text and swept across it, so the band travels.
 * Still under reduced motion.
 */
export function shimmerTextSx(
  edge: string,
  band: string
): SystemStyleObject<Theme> {
  return {
    animation: `${sweep} 2s linear infinite`,
    backgroundClip: "text",
    backgroundImage: `linear-gradient(90deg, ${edge} 0.1%, ${band} 49.9%, ${edge} 99.9%)`,
    backgroundSize: "200% 100%",
    color: "transparent",
    WebkitBackgroundClip: "text",
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  };
}
